import { BydBimModelsInterface } from '../interfaces/byd-bim-models.interface';

export class BydBimModels {
  /**
   * Id of the bim model
   */
  public id: number;

  /**
   * Id of the creator
   */
  public userId: number;

  /**
   * Name of the bim model
   */
  public name: string;

  /**
   * Create an instance of DsBimModels.
   *
   * @param jsonData the Json Data
   */
  public constructor(jsonData: BydBimModelsInterface) {
    this.id = jsonData.id || 0;
    this.userId = jsonData.user_id || 0;
    this.name = jsonData.name || '';
  }
}
